<template>
  <div id="tooltip" v-if="data" :style="transformCss">
      <span class="close" v-on:click="$emit('close-tooltip')" >&times;</span>
      <span class="date">{{formatedDate}}</span>
      <span class="location" >{{data.City}}, {{data.State}}</span>
      <hr />
      <span class="info">41.757327, -71.247056</span>
      <span class="header">TARGET</span>
      <hr />
      <span class="info">{{data.Target}}</span>
      <span class="header">TYPE</span>
      <hr />
      <span class="info">{{data.Name}}</span>
      <span class="header">DEMAND</span>
      <hr />
      <span>{{data.Demand}}</span>
      <span class="header">PAID</span>
      <hr />
      <span>{{data.Paid}}</span>
      <br />
      
      <a :href="data.Source" target="_blank" class="readfull">Read the Full Story</a>
      
    
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    x: Number,
    y: Number,
    data: Object,
    onClick: Function,
    sticky: Boolean,
    width: {
      type: Number,
      default: 172,
    }
  },
  computed: {
    transformCss: function() {
      return { transform: `translate( ${this.x}px, ${this.y}px )` };
    },
    formatedDate: function() {
      let date = new Date(this.data.Date);
      let options = { year: "numeric", month: "long" };
      return date.toLocaleDateString("en-US", options);
    }
  }
};

// TODO. implement onClick  method to trigger modal or expand tooltip
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
#tooltip {
  font-family: 'Roboto Mono', sans-serif;
  text-align: left;
  padding: 10px;
  border: 2px dotted black;
  font-size: 12px;
  border-top: 2px solid #6370c2;
  background-color: #000000;
  width: auto;
  position: absolute;
  top: 0;
  padding-top: 2px;
  color: #ffffff;
  width: 200px;
  z-index: 999999;
}
.date,
.location,
.header {
  font-weight: bold;
  
  display: block;
}
.header {
  margin-top: 5px;
}
.info {
  font-weight: normal;
}
hr {
  margin-top: 0px;
}
.readfull {
  display: block;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  text-decoration: none;
  color: #ffffff;
  margin: 0 auto;
  border: 1px solid #6370c2;
  text-align: center;
  margin-top: 20px;
}
.close {
  display: block;
  text-align: right;
  font-size: 18px;
  cursor: pointer;
}
</style>
